
define('template!adminSnippetsEditPopupView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="popup-body snippet-edit">\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(labels.shortcut) )) == null ? '' : __t) +
'</label>\n    <input type="text" class="input-shortcut form-control" value="' +
((__t = ( _.escape(shortcut) )) == null ? '' : __t) +
'" maxlength="64" />\n  </div>\n\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(labels.description) )) == null ? '' : __t) +
'</label>\n    <input type="text" class="input-description form-control" value="' +
((__t = ( _.escape(description) )) == null ? '' : __t) +
'" maxlength="255" />\n  </div>\n\n  <div class="form-row toggles">\n    <label class="toggle">\n      <input type="checkbox" class="input-enabled" ';
 if (enabled) { ;
__p += 'checked';
 } ;
__p += ' />\n      ' +
((__t = ( _.escape(labels.enabled) )) == null ? '' : __t) +
'\n    </label>\n    <label class="toggle">\n      <input type="checkbox" class="input-case-sensitive" ';
 if (caseSensitive) { ;
__p += 'checked';
 } ;
__p += ' />\n      ' +
((__t = ( _.escape(labels.caseSensitive) )) == null ? '' : __t) +
'\n    </label>\n  </div>\n\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(labels.body) )) == null ? '' : __t) +
'</label>\n    <div class="locale-tabs">\n      ';
 _.each(locales, function (loc) { ;
__p += '\n        <button type="button"\n                class="locale-tab ';
 if (loc === activeLocale) { ;
__p += 'active';
 } ;
__p += '"\n                data-locale="' +
((__t = ( _.escape(loc) )) == null ? '' : __t) +
'">' +
((__t = ( _.escape(loc.toUpperCase()) )) == null ? '' : __t) +
'</button>\n      ';
 }); ;
__p += '\n    </div>\n    <textarea class="input-body form-control" rows="10">' +
((__t = ( _.escape(activeBody) )) == null ? '' : __t) +
'</textarea>\n  </div>\n\n  <div class="error-box" style="display: none;"></div>\n</div>\n\n<div class="popup-footer">\n  <button class="btn btn-primary btn-save">' +
((__t = ( _.escape(labels.save) )) == null ? '' : __t) +
'</button>\n  <button class="btn btn-close">' +
((__t = ( _.escape(labels.close) )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};});

